import React from 'react';
import DocumentPage, {
  Section,
  Paragraph,
  DoDoNot,
} from './DocumentPage';

const FLTChangingLPGCylindersDoc = ({ onReturnHome }) => (
  <DocumentPage
    pageTitle="Changing LPG Cylinders (Forklifts) – Safe System of Work"
    documentHeading="Safe System of Work: Changing LPG Cylinders – Forklift Trucks"
    meta={[
      ['Document Reference', 'PVS-SSOW-FLT-LPG'],
      ['Version', '1.0'],
      ['Date of Issue', '17th March 2026'],
      ['Next Review Date', '17th March 2028'],
      ['Activity', 'Changing LPG cylinders on forklift trucks'],
      ['Review Period', '24 months'],
    ]}
    acknowledgment={{
      documentName: 'Changing LPG Cylinders (Forklifts) – Safe System of Work',
      documentReference: 'PVS-SSOW-FLT-LPG',
      processActivity: 'Changing LPG Cylinders on Forklift Trucks',
      versionNumber: '1.0',
      dateOfIssue: '17th March 2026',
    }}
    onReturnHome={onReturnHome}
  >
    <Section number="1" title="Introduction">
      <Paragraph>
        Liquified Petroleum Gas (LPG) e.g. propane or butane is a common type of fuel used within
        forklift trucks where it is usually supplied in cylinders. LPG is a highly flammable
        substance and needs to be handled correctly. As well as fire, other hazards that can arise
        when changing cylinders include manual handling injuries and severe cold burns if spilt or
        splashed on the skin when in liquid form.
      </Paragraph>
    </Section>

    <Section number="2" title="Safe System of Work">
      <DoDoNot
        doItems={[
          'Only change cylinders in designated areas.',
          'Before changing a cylinder switch off the vehicle engine and remove the key.',
          'Switch off the cylinder and all the electric circuits on the vehicle.',
          'Close the cylinder valve before removing the "empty" cylinder.',
          'Ensure the valve sealing gasket is in place at all times.',
          'Place the new cylinder on the vehicle with the arrow facing downwards.',
          'Re-couple with the cylinder valve closed.',
          'Check for evidence of leaks (frosting, hissing).',
          'Ensure the used cylinder is stored correctly.',
          'Check the cylinder is firmly secured before operating the vehicle.',
        ]}
        doNotItems={[
          'Carry out this operation unless trained and authorised.',
          'Smoke or have any ignition sources in the vicinity of any aspect of this operation.',
          'Lift above your capacity, obtain assistance if required to lift cylinders.',
          'Operate the truck without the cylinder firmly secured.',
          'Carry out any aspect of operation with the forklift ignition circuit being live.',
        ]}
      />
    </Section>

    <Section number="3" title="Reminder">
      <Paragraph className="font-semibold">
        IF YOU HAVE ANY QUESTIONS, PLEASE ASK YOUR MANAGER OR SUPERVISOR. You have a duty not only
        to protect your own health and safety but also to ensure that your actions do not put others
        around you at risk.
      </Paragraph>
    </Section>
  </DocumentPage>
);

export default FLTChangingLPGCylindersDoc;
